import styled from 'styled-components/macro';
import { colorBlackTransparent300, FILTER_DROP_SHADOW_DEFAULT, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel4 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
export const HeroComponentStyled = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 154px;
  overflow-wrap: break-word;

  aspect-ratio: ${AspectRatio.RectangleLevel2};

  ${ADAPTIVE.minWidth.tablet} {
    min-height: 330px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: 617px;
    max-width: 1920px;
    margin: 0 auto;

    aspect-ratio: ${AspectRatio.RectangleLevel1};
  }
`;
export const ImageBgStyled = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  picture {
    img {
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
`;
export const SeparatorElementStyled = styled(HeadingLevel4) `
  display: inline-block;
  margin-left: ${INDENT.xxxs};
  margin-right: ${INDENT.xxxs};

  ${ADAPTIVE.minWidth.tablet} {
    margin-left: ${INDENT.xxs};
    margin-right: ${INDENT.xxs};
  }
`;
export const ImageMaskStyled = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }
`;
export const HeadingLevel4Styled = styled(HeadingLevel4) `
  display: inline;
`;
export const SubTitleContent = styled.div `
  filter: ${FILTER_DROP_SHADOW_DEFAULT};

  ${ADAPTIVE.minWidth.tablet} {
    margin-bottom: ${INDENT.xxxxs};
  } ;
`;
